import React from 'react'
import {Container, Col, Row} from 'react-bootstrap'
import EventsCalendar from '../../components/EventsCalendar'

export default function index() {
    
    return (
        <div>
        
            <Container>
                <Row>
                    <Col>
                    <p className='mainFont' style={{fontSize: '1em'}}>Here you can find upcoming events</p>
                    <p className='mainFont' style={{fontSize: '1.5em'}}>Upcoming Events</p>
                    <EventsCalendar/>
                    </Col>
                </Row>
            </Container>
            <br />
            <br />          
        </div>
    )
}
